import gql from 'graphql-tag';

export const GET_EMAILS_FOR_EMAIL_APPLICATIONS_QUERY = gql`
  query GetEmailsForEmailApplicationsQuery($clientId: String!) {
    emails: getEmailsForEmailApplications(clientId: $clientId)
  }
`;

export const GET_IGDM_RESOURCES_QUERY = gql`
  query GetIGDMResourcesQuery($clientId: String!) {
    igdmResources: getIGDMResources(clientId: $clientId)
  }
`;

export const DEPRECATE_AUTH_PROVIDER_MUTATION = gql`
  mutation DeprecateAuthProviderMutation($userExternalDisplayId: String!) {
    deprecated: deprecateAuthProvider(userExternalDisplayId: $userExternalDisplayId)
  }
`;

export const GET_EMAIL_RESOURCES_FOR_CLIENT_QUERY = gql`
  query GetEmailResourcesForClientQuery($clientId: String!) {
    resources: getEmailResourcesForClient(clientId: $clientId) {
      id
      isAdmin
      authProvider {
        userExternalDisplayId
        isShared
      }
      activeGrants {
        id
        grantedUserId
        reason
        createdDate
      }
    }
  }
`;

export const GRANT_RESOURCE_ACCESS_MUTATION = gql`
  mutation GrantResourceAccessMutation($resourceId: Int!, $targetUserId: String!, $reason: String) {
    grant: grantResourceAccess(resourceId: $resourceId, targetUserId: $targetUserId, reason: $reason) {
      id
      grantedUserId
      grantedResourceId
    }
  }
`;

export const REVOKE_RESOURCE_ACCESS_MUTATION = gql`
  mutation RevokeResourceAccessMutation($grantId: Int!) {
    revoked: revokeResourceAccess(grantId: $grantId)
  }
`;
